import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import store from "../../store";
import {showSuccessNotification} from "../../actions/actionFunctions";

class SuccessNotification extends React.Component {

  state = {
    opened: false,
    isHiding: false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successNotification.show && !this.props.successNotification.show) {
      setTimeout(() => {  // let it render first
        this.setState({
          opened: true
        })
      }, 0)
    } else if (!nextProps.successNotification.show && this.props.successNotification.show) {
      this.setState({
        isHiding: true,
        opened: false
      }, () => {
        setTimeout(() => {
          this.setState({
            isHiding: false
          })
        }, 500)
      })
    }
  }

  render() {
    const {show, icon, title, message} = this.props.successNotification;

    return show || this.state.isHiding ? (
      <div className={"unc-step bg-active unc-step--notification" + (this.state.opened ? " unc-step--notification--show" : "")}>
        <div className="unc-step-content">
          <div className={"unc-step-content__icon unc-step-content__icon--" + icon} />
          <div className="unc-step-content__text">
            <p className="unc-title"><FormattedMessage id={title}/></p>
            <p className="unc-calculating">
              <span className="unc-calculating__text"><FormattedMessage id={message}/></span>
            </p>
          </div>
        </div>
      </div>
    ) : null;
  }

}

const mapStateToProps = (store) => {
  return {
    successNotification: store.serverState.successNotification,
  };
};

export default connect(mapStateToProps, {})(SuccessNotification);

export const showQuoteSavedNotification = (title = "successNotification.titleQuoteSaved") => {
  if (document.kvConfig.visualizerOnly && (title === "successNotification.titleQuoteSaved")) {
    title = "successNotification.titleDesignSaved";
  }
  if (store.getState().serverState.successNotification) {
    window.clearTimeout(window.saveQuoteTimeoutId);
    store.dispatch(showSuccessNotification({
      show: false
    }));
  }
  store.dispatch(showSuccessNotification({
    show: true,
    icon: "calculate",
    title,
    message: "successNotification.messageQuoteSaved"
  }));
  window.saveQuoteTimeoutId = setTimeout(() => {
    store.dispatch(showSuccessNotification({
      show: false
    }));
  }, 3000)
}
